import { DependenciesInjection } from "app/di/DependencyInjection";
import { B2CUserManagementImpl } from "../data/B2CUserManagementImpl";
import { IB2CUserRepository } from "../domain/repositories/IB2CUserRepository";
import { B2CUserManagementUseCase } from "../domain/useCases/B2CUserManagementUseCase";
import { StaffManagementViewModel } from "../presentation/viewModel/staffManagementViewModel/StaffManagementViewModel";
import { StoreManagerViewModel } from "../presentation/viewModel/storeManagerManagementViewModel/StoreManagerManagementViewModel";
import { UserChainManagementViewModel } from "../presentation/viewModel/userChainManagementViewModel/UserChainManagementViewModel";
import { B2CUserToken } from "./B2CUserToken";

export class B2CUserInjection {
  private static injectVM() {
    DependenciesInjection.register<StaffManagementViewModel>(
      B2CUserToken.StaffManagementViewModel,
      StaffManagementViewModel,
      "viewModel",
    );
    DependenciesInjection.register<StoreManagerViewModel>(
      B2CUserToken.StoreManagerViewModel,
      StoreManagerViewModel,
      "viewModel",
    );
    DependenciesInjection.register<UserChainManagementViewModel>(
      B2CUserToken.UserChainManagementViewModel,
      UserChainManagementViewModel,
      "viewModel",
    );
  }

  static initInjection() {
    DependenciesInjection.register<IB2CUserRepository>(
      B2CUserToken.IB2CUserRepository,
      B2CUserManagementImpl,
      "otherRepo",
    );
    DependenciesInjection.register<B2CUserManagementUseCase>(
      B2CUserToken.B2CUserManagementUseCase,
      B2CUserManagementUseCase,
      "otherRepo",
    );
    this.injectVM();
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IB2CUserRepository>(
      B2CUserToken.IB2CUserRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<B2CUserManagementUseCase>(
      B2CUserToken.B2CUserManagementUseCase,
    );
  }
}
